// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: kvajJ2MSr9DNMA2u1PusCw
// Component: Asiz7K-bnpQ2
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import projectcss from "../blank_project/plasmic_blank_project.module.css"; // plasmic-import: kvajJ2MSr9DNMA2u1PusCw/projectcss
import sty from "./PlasmicJsonListItem.module.css"; // plasmic-import: Asiz7K-bnpQ2/css

createPlasmicElementProxy;

export const PlasmicJsonListItem__VariantProps = new Array();

export const PlasmicJsonListItem__ArgProps = new Array();

const $$ = {};

function PlasmicJsonListItem__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"txt"}
        data-plasmic-override={overrides.txt}
        className={classNames(projectcss.all, projectcss.__wab_text, sty.txt)}
      >
        {"Enter some text"}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "txt"],
  txt: ["txt"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicJsonListItem__ArgProps,
          internalVariantPropNames: PlasmicJsonListItem__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicJsonListItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicJsonListItem";
  } else {
    func.displayName = `PlasmicJsonListItem.${nodeName}`;
  }
  return func;
}

export const PlasmicJsonListItem = Object.assign(
  // Top-level PlasmicJsonListItem renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    txt: makeNodeComponent("txt"),
    // Metadata about props expected for PlasmicJsonListItem
    internalVariantProps: PlasmicJsonListItem__VariantProps,
    internalArgProps: PlasmicJsonListItem__ArgProps
  }
);

export default PlasmicJsonListItem;
/* prettier-ignore-end */
